import {IPrintableCalenderService} from "../../../services/printableCalendarService";

export interface IPrintableCalendarDomainStore {
  downloadPrintableCalender(
    filename: string,
    month: string,
    villageId: string,
    calendarName: string,
    sectionName?: string
  ): Promise<void>;
}

export class PrintableCalendarDomainStore
  implements IPrintableCalendarDomainStore
{
  printableCalenderService: IPrintableCalenderService;

  constructor(printableCalenderService: IPrintableCalenderService) {
    this.printableCalenderService = printableCalenderService;
  }

  downloadPrintableCalender(
    filename: string,
    month: string,
    villageId: string,
    calendarName: string,
    sectionName?: string
  ) {
    return this.printableCalenderService.downloadPrintableCalender(
      filename,
      month,
      villageId,
      calendarName,
      sectionName
    );
  }
}
